// extracted by mini-css-extract-plugin
module.exports = {"firstRow":"style_firstRow__5_XdE","element":"style_element__JXfgC","icon":"style_icon___53o7","data":"style_data__7CtGW","label":"style_label__VhAHb","value":"style_value__k8S81"};